import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Link, { navigateTo, withPrefix } from "gatsby-link";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { normalize } from "polished";
import theme from "../theme.js";

import { Box, Flex, Text } from "rebass";
import { Algolia, Footer, Header } from "components";
import MobileBar from "../components/MobileBar.js";

const GlobalStyle = createGlobalStyle`
  ${normalize()}
  * {
    box-sizing: border-box;
    &::selection {
      color: #fff;
      background-color: #7673c0;
    }
  }
  html {
    lang: en-us;
    height: 100%;
    font-family: 'Noto Sans', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    &:not(:lang(ar)) { direction: ltr; }
    &:lang(ar) { direction: rtl; }
  }
  body {
    background-color: #7673c0;
    transition: background-color 800ms ease;
  }
  a { text-decoration: none; }
`;

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: "English",
      windowLang: "en-us",
      altLanguages: undefined,
      navMessage: "",
    };
    this.node = undefined;
  }
  componentDidMount(props) {
    if (
      window.location.href !== "https://bankinformationcenter.org/" &&
      window.location.href !== "http://bic-field.netlify.com/" &&
      window.location.href !== "http://localhost:8000/" &&
      window.location.href !== "http://localhost:8000/___graphql" &&
      window.location.href !== "https://bankinformationcenter.org/thanks" &&
      window.location.href !== "http://localhost:8000/thanks"
    ) {
      if (
        window.location.href.indexOf("en-us") === -1 &&
        window.location.href.indexOf("ar-eg") === -1 &&
        window.location.href.indexOf("es-mx") === -1
      ) {
        const split = window.location.href.split("/");
        let finalSplit = "";
        split.forEach((element, index) => {
          if (index === 3) {
            finalSplit += "en-us/";
          }
          if (index !== split.length - 1) {
            finalSplit += element + "/";
          } else {
            finalSplit += element;
          }
        });
        window.location = finalSplit;
      } else {
        if (window.location.href.indexOf("en-us") !== -1) {
          this.setState({ language: "English", windowLang: "en-us" });
        }
        if (window.location.href.indexOf("es-mx") !== -1) {
          this.setState({ language: "Spanish", windowLang: "es-mx" });
        }
        if (window.location.href.indexOf("ar-eg") !== -1) {
          this.setState({ language: "Arabic", windowLang: "ar-eg" });
        }
      }
    } else {
      this.setState({ language: "English", windowLang: "en-us" });
    }
    this.determineColor(window.location.href);
    this.setLang(window.location.href);
    this.setState({ mounted: true });
  }

  determineColor = (region) => {
    let color = "violet";
    if (
      region.indexOf("update") !== -1 ||
      region.indexOf("institution") !== -1 ||
      region.indexOf("campaign") !== -1 ||
      region === null ||
      region === undefined
    ) {
      if (
        region.indexOf("institutions") === -1 &&
        region.indexOf("campaigns") === -1 &&
        region.indexOf("updates") === -1
      ) {
        color = "violet";
      }
    }
    if (region.indexOf("region") !== -1) {
      if (region.indexOf("africa") !== -1) {
        color = "green";
      }
      if (region.indexOf("middle-east-and-north-africa") !== -1) {
        color = "orange";
      }
      if (region.indexOf("latin-america") !== -1) {
        color = "blue";
      }
      if (region.indexOf("asia") !== -1) {
        color = "pink";
      }
      if (region.indexOf("europe--central-asia") !== -1) {
        color = "yellow";
      }
    }
    if (
      (region.indexOf("project") === -1 && region.indexOf("update") === -1) ||
      region.indexOf("updates") !== -1
    ) {
      if (region.split("/")[region.split("/").length - 1] === "") {
        document.body.style.background = "white";
      } else {
        document.body.style.background = theme.colors[color];
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setLang(nextProps.location.pathname);
      this.determineColor(nextProps.location.pathname);
    }
  }

  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.navMessage !==
        "Navigated to " + document.title.split("|")[0]
      ) {
        this.setState({
          navMessage: "Navigated to " + document.title.split("|")[0],
        });
      }
    }, 500);
    if (this.node) {
      this.node.focus();
    }
  }

  setAltLanguages = (altLanguages) => {
    this.setState({ altLanguages: altLanguages });
  };

  setLang(url) {
    document.documentElement.lang = "en-us";
    if (url.indexOf("es-mx") !== -1) {
      document.documentElement.lang = "es-mx";
    }
    if (url.indexOf("ar-eg") !== -1) {
      document.documentElement.lang = "ar-eg";
    }
  }

  changeLang = (lang) => {
    let alt = false;
    if (this.state.altLanguages) {
      if (this.state.altLanguages[0]) {
        alt = true;
        this.state.altLanguages.forEach((element) => {
          if (lang === "English") {
            if (element.lang === "en-us") {
              window.location.href =
                "/en-us/" +
                (element.type !== "projec" ? element.type : "project") +
                "/" +
                element.uid;
            }
          }
          if (lang === "Arabic") {
            if (element.lang === "ar-eg") {
              window.location.href =
                "/ar-eg/" +
                (element.type !== "projec" ? element.type : "project") +
                "/" +
                element.uid;
            }
          }
          if (lang === "Spanish") {
            if (element.lang === "es-mx") {
              window.location.href =
                "/es-mx/" +
                (element.type !== "projec" ? element.type : "project") +
                "/" +
                element.uid;
            }
          }
        });
      }
    }
    if (!alt) {
      if (lang === "English") {
        if (
          window.location === "https://bankinformationcenter.org/ar-eg/" ||
          "https://bankinformationcenter.org/es-mx/"
        ) {
          window.location = "https://bankinformationcenter.org/";
        }
        if (window.location.href.indexOf("en-us") === -1) {
          if (window.location.href.indexOf("ar-eg") !== -1) {
            if (
              window.location.href ===
                "https://bankinformationcenter.org/ar-eg/" ||
              window.location.href === "http://localhost:8000/ar-eg/"
            ) {
              window.location.href = window.location.href.replace(
                "/ar-eg/",
                "/"
              );
            } else {
              window.location.href = window.location.href.replace(
                "ar-eg",
                "en-us"
              );
            }
          }
          if (window.location.href.indexOf("es-mx") !== -1) {
            if (
              window.location.href ===
                "https://bankinformationcenter.org/es-mx/" ||
              window.location.href === "http://localhost:8000/es-mx/"
            ) {
              window.location.href = window.location.href.replace(
                "/es-mx/",
                "/"
              );
            } else {
              window.location.href = window.location.href.replace(
                "es-mx",
                "en-us"
              );
            }
          }
        }
      }
      if (lang === "Arabic") {
        if (window.location.href.indexOf("ar-eg") === -1) {
          if (window.location.href.indexOf("en-us") !== -1) {
            window.location.href = window.location.href.replace(
              "en-us",
              "ar-eg"
            );
          }
          if (window.location.href.indexOf("es-mx") !== -1) {
            window.location.href = window.location.href.replace(
              "es-mx",
              "ar-eg"
            );
          }
          if (
            window.location.href === "https://bankinformationcenter.org/" ||
            window.location.href === "http://bic-field.netlify.com/" ||
            window.location.href === "http://localhost:8000/" ||
            window.location.href === "http://localhost:8000/___graphql"
          ) {
            window.location.href = window.location.href + "ar-eg/";
          }
        }
      }
      if (lang === "Spanish") {
        if (window.location.href.indexOf("es-mx") === -1) {
          if (window.location.href.indexOf("en-us") !== -1) {
            window.location.href = window.location.href.replace(
              "en-us",
              "es-mx"
            );
          }
          if (window.location.href.indexOf("ar-eg") !== -1) {
            window.location.href = window.location.href.replace(
              "ar-eg",
              "es-mx"
            );
          }
          if (
            window.location.href === "https://bankinformationcenter.org/" ||
            window.location.href === "http://bic-field.netlify.com/" ||
            window.location.href === "http://localhost:8000/" ||
            window.location.href === "http://localhost:8000/___graphql"
          ) {
            window.location.href = window.location.href + "es-mx/";
          }
        }
      }
    }
    if (lang === "English") {
      document.documentElement.lang = "en-us";
    }
    if (lang === "Arabic") {
      document.documentElement.lang = "ar-eg";
    }
    if (lang === "Spanish") {
      document.documentElement.lang = "es-mx";
    }
    this.setState({
      language: lang,
      windowLang: document.documentElement.lang,
    });
  };

  static childContextTypes = {
    setAltLanguages: PropTypes.func,
  };
  getChildContext() {
    return { setAltLanguages: this.setAltLanguages };
  }

  render() {
    if (this.props.data.campaigns) {
      this.props.data.campaigns.edges.sort(function (a, b) {
        if (a.node.uid < b.node.uid) return -1;
        if (a.node.uid > b.node.uid) return 1;
        return 0;
      });
    }
    if (this.props.data.institutions) {
      this.props.data.institutions.edges.sort(function (a, b) {
        if (a.node.uid < b.node.uid) return -1;
        if (a.node.uid > b.node.uid) return 1;
        return 0;
      });
    }
    if (this.props.data.regions) {
      this.props.data.regions.edges.sort(function (a, b) {
        if (a.node.uid < b.node.uid) return -1;
        if (a.node.uid > b.node.uid) return 1;
        return 0;
      });
    }
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <div ref={(n) => (this.node = n)} tabIndex={-1}>
          <div role="status" aria-live="polite" aria-atomic="true">
            {this.state.navMessage}
          </div>
          <Helmet>
            <script>{`
              window.markerConfig = {
                project: '637d24536ca403dd22405084', 
                source: 'snippet'
              };
            `}</script>
            <script>{`
            !function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);
            `}</script>
          </Helmet>
          <Helmet
            title="Bank Information Center"
            meta={[
              { name: "application-name", content: "Bank Information Center" },
              { name: "msapplication-TileColor", content: "#7673C0" },
              {
                name: "msapplication-TileImage",
                content: withPrefix("/favicons/mstile-144x144.png"),
              },
            ]}
            link={[
              {
                rel: "icon",
                type: "image/x-icon",
                href: withPrefix("/favicons/favicon.ico"),
              },
              {
                rel: "icon",
                type: "image/png",
                href: withPrefix("/favicons/favicon-32x32.png"),
                sizes: "32x32",
              },
              {
                rel: "icon",
                type: "image/png",
                href: withPrefix("/favicons/favicon-16x16.png"),
                sizes: "16x16",
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "57x57",
                href: withPrefix("/favicons/apple-touch-icon-57x57.png"),
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "72x72",
                href: withPrefix("/favicons/apple-touch-icon-72x72.png"),
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "114x114",
                href: withPrefix("/favicons/apple-touch-icon-114x114.png"),
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "120x120",
                href: withPrefix("/favicons/apple-touch-icon-120x120.png"),
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "144x144",
                href: withPrefix("/favicons/apple-touch-icon-144x144.png"),
              },
              {
                rel: "apple-touch-icon-precomposed",
                sizes: "152x152",
                href: withPrefix("/favicons/apple-touch-icon-152x152.png"),
              },
            ]}
          />
          <Header
            changeLang={this.changeLang}
            currentLang={this.state.language}
            props={this.props}
            windowLang={this.state.windowLang}
          />
          {this.props.children()}
          <Footer
            changeLang={this.changeLang}
            currentLang={this.state.language}
            windowLang={this.state.windowLang}
          />
          {this.state.mounted && (
            <div>
              {window.location.href.split("/")[
                window.location.href.split("/").length - 1
              ] === "" && (
                <MobileBar
                  emailAddress="info@bankinformationcenter.org"
                  phoneNumber="+1 (202) 737-7752"
                  windowLang={this.state.windowLang}
                />
              )}
            </div>
          )}
        </div>
      </ThemeProvider>
    );
  }
}

Index.propTypes = {
  children: PropTypes.func,
};

if (typeof document !== "undefined") {
  (function (l) {
    var i,
      s = { touchend: function () {} };
    for (i in s) l.addEventListener(i, s);
  })(document); // sticky hover fix in iOS
}

export const query = graphql`
  query HeaderQuery {
    regions: allPrismicDocument(filter: { type: { eq: "region" } }) {
      edges {
        node {
          uid
          lang
          data {
            title {
              text
            }
          }
        }
      }
    }
    campaigns: allPrismicDocument(filter: { type: { eq: "campaign" } }) {
      edges {
        node {
          type
          uid
          lang
          data {
            show_in_navigation
            title {
              text
            }
          }
        }
      }
    }
    landing_pages: allPrismicDocument(
      filter: { type: { eq: "landing_page" } }
    ) {
      edges {
        node {
          type
          uid
          lang
          data {
            show_in_navigation
            title {
              text
            }
          }
        }
      }
    }
    institutions: allPrismicDocument(filter: { type: { eq: "institution" } }) {
      edges {
        node {
          uid
          lang
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js